<div *ngIf="loading" id="loader" class="text-center p-t-lg p-b-lg">
  <em class="fa fa-light fa-spinner fa-spin"></em>
</div>
<ng-container *ngIf="alerts$ | async as alerts">
  <div class="box card-box" [ngClass]="!tableOnly ? 'm-x-sm' : 'no-bg'">

    <div class="box-header" *ngIf="!tableOnly">
      <h3>{{ 'ALERTS.contract_alerts' | translate }}</h3>
    </div>

    <div class="box-body alerts-content">
      <gp-table class="table">
        <thead gp-table-head>
        <tr role="row">
          <th id="creation" width="160px" class="text-uppercase text-xs" gp-table-column>
            {{ 'COMMON.date' | translate }}
          </th>
          <th id="category" class="text-uppercase text-xs" gp-table-column>
            {{ 'COMMON.category' | translate }}
          </th>
          <th id="dates" class="text-uppercase text-xs" gp-table-column>
            {{ 'COMMON.beginDate' | translate }} - {{ 'COMMON.endDate' | translate }}
          </th>
          <th id="message" class="text-uppercase text-xs" gp-table-column>
            {{ 'COMMON.message' | translate }}
          </th>
          <th id="blocking" class="text-uppercase text-xs" gp-table-column>
            {{ 'ALERTS.blocking' | translate }}
          </th>
          <th id="filters" gp-table-column>
            <div class="pull-right">
              <button class="btn btn-sm btn-icon white" [class.active]="filtersVisible"
                      (click)="filtersVisible = !filtersVisible" tooltip="{{ 'TOOLTIPS.filters' | translate }}"
                      [disabled]="!alerts.length">
                <em class="fa fa-light fa-filter pointer"></em>
              </button>
            </div>
          </th>
        </tr>
        <tr class="row filters" [attr.data-hidden]="!filtersVisible">
          <td></td>
          <td>
            <input type="text" [(ngModel)]="category"
                   class="form-control b-a form-group-sm search-field"
                   (keydown.enter)="$event.preventDefault()">
          </td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let alert of alerts | filterAlerts: category: (triggerLanguageChange$|async)" class="alert-row">
          <td headers="creation" width="200"
              class="font-weight-600">{{ alert.creationDate | gpDate:{withTime: true} }}
          </td>
          <td headers="category">
            <div *ngFor="let zone of alert.zones">
              <span *ngIf="zone.metadata?.structureType !== 'REP'; else repZoneCategory" class="zone-link" [ngClass]="{
              'forbidden': zone.name === NO_ZONE_ACCESS.ZONE_NAME,
              'rep-zone': zone.metadata?.structureType === 'REP'}"
                    (click)="updateZoneName(zone.name)">
                {{ zone.transIds | getTransIdsDisplay: (triggerLanguageChange$|async) }}
                &nbsp;<em class="fa fa-light fa-arrow-alt-circle-right"
                          *ngIf="(zone.name !== NO_ZONE_ACCESS.ZONE_NAME)"></em>
              </span>
              <ng-template #repZoneCategory>
                <div class="font-weight-bold">
                  {{ zone.transIds | getTransIdsDisplay: (triggerLanguageChange$|async) }}
                </div>
                <div>
                  ( {{ zone.metadata.entityTreeTransId | translate }}
                  - {{ zone.metadata.entityTypeTransId | translate }})
                </div>
              </ng-template>
            </div>
          </td>
          <td headers="dates">
            <div class="font-weight-600" *ngIf="alert.beginDate && alert.endDate">
              <span
                class="alert-date">{{ alert.beginDate === '1970-01-01' ? '- &#8734;' : alert.beginDate | gpDate: {}: (triggerDateChange$|async) }}</span>
              -
              <span
                class="alert-date">{{ alert.endDate === '3000-01-01' ? '+ &#8734;' : alert.endDate | gpDate: {}: (triggerDateChange$|async) }}</span>
            </div>
          </td>
          <td headers="message">
            <div class="font-weight-bold"
                 [ngClass]="{ 'forbidden': alert.transId === NO_ZONE_ACCESS.MESSAGE}">{{ alert.transId | translate }}
            </div>
          </td>
          <td headers="blocking" colspan="2">
            <div>
              <span class="alert-blocking" *ngFor="let blocked of alert.blocking"
                    [ngClass]="'alert-blocking-' + blocked">
                <em class="fa fa-light fa-times-circle"></em><span>{{ ('ALERTS.blocking.' + blocked) | translate }}</span>
              </span>
            </div>
          </td>
        </tr>
        </tbody>
      </gp-table>
      <div *ngIf="!loading && (alerts | filterAlerts: category: (triggerLanguageChange$|async)).length === 0">
        <gp-illustrated-message [text]="'ALERTS.alerts_not_found'" [width]="'65%'"></gp-illustrated-message>
      </div>
    </div>
  </div>
</ng-container>
